export enum UniswapEventName {
  BalancesReport = 'Balances Report',
  BalancesReportPerChain = 'Balances Report Per Chain',
  TokenSelected = 'Token Selected',
  ConversionEventSubmitted = 'Conversion Event Submitted',
}
